import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import RightModal from '../../../../../components/shared/RightModal';
import ModalHeader from '../../../../../components/Automations/ChatbotAI/ModalHeader';
import TooltipMC from '../../../../components/TooltipMC';
import IconMC from '../../../../components/IconMC';
import PlaygroundCustomerSelect from '../Playground/PlaygroundCustomerSelect';
import Events from './Events';
import Steps from './Steps';
import Knowledges from './Knowledges';

const MemoryModal = ({
  isOpen,
  onClose,
  customerId,
  sessionSlug = '',
  testCustomerOptions = [],
  onCustomerChange,
  canReset = false,
  onReset,
  resetting = false,
  refreshKey
}) => {
  const { t } = useTranslation('ChatbotIA');

  const [sections, setSections] = useState({
    eventsOpened: false,
    stepsOpened: false,
    knowledgeOpened: false,
  });

  const renderIconName = (opened) => (
    opened ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'
  );

  const handleSections = (section) => {
    const newSections = { ...sections };
    Object.keys(newSections).forEach((sec) => {
      if (sec === `${section}Opened`) {
        newSections[sec] = !newSections[sec];
      } else {
        newSections[sec] = false;
      }
    });
    setSections(newSections);
  };

  if (!isOpen) return null;

  return (
    <RightModal>
      <div className="tw-wrapper mercately-modal tw-w-full tw-max-w-[520px] tw-bg-white tw-rounded-[16px] tw-shadow-lg">
        <ModalHeader
          title={t('memory.playground.title')}
          toggleModal={onClose}
          centeredTitle={false}
        />

        <div className="pt-32 px-24">
          <span className="fz-12" style={{ color: '#45535F' }}>
            {t('memory.playground.description')}
          </span>
          {customerId && (
            <div className="tw-mt-1">
              <span className="fz-12 tw-font-semibold" style={{ color: '#45535F' }}>
                {t('memory.playground.customer_id')}
              </span>
              <span className="fz-12 tw-ml-1 tw-break-all" style={{ color: '#198FCC' }}>
                {customerId}
              </span>
            </div>
          )}
        </div>

        <div className="mia_modal_body">
          <div className="align align-items-stretch d-flex flex-column px-16"
            style={{
              borderRadius: 12,
              border: '1px solid var(--Gray-200, #D6DCE1)',
              background: '#FFF'
            }}>

            <div className="align-items-center d-flex justify-content-between">
              <span className="font-600 fz-14 lh-24 py-16 text-gray-950">{t('memory.title')}</span>
              {canReset && (
                <TooltipMC text={t('memory.reset')} position="bottom">
                  <button
                    type="button"
                    className="tw-flex tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-red-500 disabled:tw-opacity-50"
                    onClick={onReset}
                    disabled={resetting}
                    aria-label={t('memory.reset')}
                  >
                    <i className="mi-trash-2-outline fs-16" aria-hidden="true" />
                  </button>
                </TooltipMC>
              )}
            </div>

            {testCustomerOptions.length > 0 && sessionSlug && (
              <div className="tw-pb-3">
                <PlaygroundCustomerSelect
                  value={customerId || sessionSlug}
                  options={testCustomerOptions}
                  sessionValue={sessionSlug}
                  sessionLabel={sessionSlug}
                  label={t('general.playground_customer.label')}
                  onChange={onCustomerChange}
                />
              </div>
            )}

            <div className="divider-line p-relative"></div>

            <div className="align-items-center cursor-pointer d-flex justify-content-between" onClick={() => handleSections("steps")}>
              <span className="font-600 fz-14 lh-24 py-16 text-gray-950">{t('memory.playground.steps')}</span>
              <IconMC name={renderIconName(sections.stepsOpened)} size="base" className="tw-text-gray-500" />
            </div>
            {sections.stepsOpened && (
              <Steps refreshKey={refreshKey} customerId={customerId} />
            )}

            <div className="divider-line p-relative"></div>

            <div className="align-items-center cursor-pointer d-flex justify-content-between" onClick={() => handleSections("events")}>
              <span className="font-600 fz-14 lh-24 py-16 text-gray-950 font-500">{t('memory.playground.events')}</span>
              <IconMC name={renderIconName(sections.eventsOpened)} size="base" className="tw-text-gray-500" />
            </div>
            {sections.eventsOpened && (
              <Events refreshKey={refreshKey} customerId={customerId} />
            )}

            <div className="divider-line p-relative"></div>

            <div className="align-items-center cursor-pointer d-flex justify-content-between" onClick={() => handleSections("knowledge")}>
              <span className="font-600 fz-14 lh-24 py-16 text-gray-950">{t('memory.playground.knowledges')}</span>
              <IconMC name={renderIconName(sections.knowledgeOpened)} size="base" className="tw-text-gray-500" />
            </div>
            {sections.knowledgeOpened && (
              <Knowledges refreshKey={refreshKey} customerId={customerId} />
            )}
          </div>
        </div>
      </div>
    </RightModal>
  );
};

export default MemoryModal;
